import { decisioningStudioTiers } from "./constants";

/**
 * Pro agents are managed by the BrazeAI Decisioning Studio team and are read-only in the
 * dashboard (ADX-1101). Strictly PRO: unknown or missing tiers remain editable by design.
 */
export const isReadOnlyUseCase = (tier?: string): boolean => tier === decisioningStudioTiers.PRO;
